<template>
  <div class="goods-container">
    <div class="d-flex align-items-center">
      <span style="font-size: 18px;font-weight: 600; color: #2B3447 ">
        {{ $l('table_label_goods_spec_list') || '产品规格明细' }}
      </span>
      <el-divider
        direction="vertical"
        v-if="!disabled || !auditDisabled"
      ></el-divider>
      <div v-if="!disabled || !auditDisabled">
        <b-button
          @click="addSpec"
          size="sm"
          class="ml-2"
          variant="outline-success"
        >
          {{ $l('table_label_add_spec') || '新增规格' }}
        </b-button>
      </div>
    </div>
    <div class="goods-list-info__container">
      <div v-for="(item, index) in specList" :key="index">
        <GoodsInfo
          :currIndex="index"
          :specInfo="item"
          :disabled="disabled"
          :auditDisabled="auditDisabled"
          :orderCode="orderCode"
          @checkSpec="checkSpec"
          @delCheck="delCheck"
          @addGoods="addGoods"
        ></GoodsInfo>
      </div>
      <div v-if="isEmpty" class="no-data__wrapper">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
    <GoodsSpecSetting
      v-if="goodsBatchVisible"
      :visible.sync="goodsBatchVisible"
      :disabled="disabled"
      :auditDisabled="auditDisabled"
      :title="title"
      :orderCode="orderCode"
      :orderTechPricingCode="orderTechPricingCode"
      :orderTechPricingSpecCode="orderTechPricingSpecCode"
      @close="closeGoodsSpecSetting"
      @saveBatch="saveBatch"
    ></GoodsSpecSetting>
  </div>
</template>
<script>
import GoodsInfo from './goods-info'
import GoodsSpecSetting from './goods-spec-setting'
import EditLoading from '@/mixins/edit-loading'
import { cloneDeep } from 'lodash'
export default {
  components: { GoodsInfo, GoodsSpecSetting },
  props: {
    disabled: { type: Boolean, default: true },
    auditDisabled: { type: Boolean, default: true },
    detailList: { type: Array, default: () => [] },
    orderTechPricingCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
  },
  mixins: [EditLoading],
  watch: {
    detailList: {
      handler() {
        this.specList = cloneDeep(this.detailList || [])
      },
      immediate: true,
    },
  },
  data() {
    return {
      specList: [],
      checkSpecList: [],
      orderTechPricingSpecCode: '',
      title: '',
      goodsBatchVisible: false,
    }
  },
  mounted() {},
  computed: {
    isEmpty() {
      return !this.specList.length
    },
  },
  methods: {
    checkSpec(e) {
      this.checkSpecList.push({ ...e })
    },
    delCheck({ orderTechPricingSpecCode }) {
      const index = this.checkSpecList.findIndex(
        (item) => item.orderTechPricingSpecCode === orderTechPricingSpecCode
      )
      this.checkSpecList.splice(index, 1)
    },
    addSpec() {
      if (!this.orderTechPricingCode) {
        this.$message.warning(
          this.$l('tip_label_add_spec') || '请保存主信息后新增规格'
        )
        return
      }
      this.goodsBatchVisible = true
      this.title = this.$l('form_label_edit_tech') || '编辑规格工时工价'
    },
    addGoods(code) {
      this.goodsBatchVisible = true
      this.orderTechPricingSpecCode = code
      this.title = this.$l('form_label_edit_tech') || '编辑规格工时工价'
    },
    async saveBatch(goodsData) {
      this.loadingOpen()
      const saveApi = this.auditDisabled
        ? this.$api.orderTechPricingGoodsSpecSaveApi
        : this.$api.orderTechPricingAuditSaveApi
      await saveApi({
        ...goodsData,
        orderTechPricingCode: this.orderTechPricingCode,
        orderTechPricingSpecCode: this.orderTechPricingSpecCode,
      })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.checkSpecList = []
          this.closeGoodsSpecSetting()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },

    closeGoodsSpecSetting() {
      this.orderTechPricingSpecCode = ''
      this.goodsBatchVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.no-data__wrapper {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.goods-list-info__container {
  margin-top: 10px;
}
</style>
